import { FieldType } from '../../../enums/field-type.enum';


export class Field {
    get containsTaxonomyId(): boolean {
        return this.taxonomyId && this.taxonomyId !== 0;
    }

    constructor(
        public id?: number,
        public taxonomyId?: number,
        public type?: FieldType,
        public name?: string,
        public hidden?: boolean,
        public mandatory?: boolean,
        public characterLimit?: number,
        public delimiter?: string,
        public dateFormat?: string,
        public mdmEntity?: string,        
        public staticValue?: string,
        public displayCode?: string) { }
}
